document.addEventListener('DOMContentLoaded', function () {
  function initCarousel(cardEl) {
    const id = cardEl.dataset.carousel;
    const track = document.getElementById(id);
    if (!track) return;

    const slides = Array.from(track.querySelectorAll('.carousel-slide'));
    let current = 0;

    const deskPrev = cardEl.querySelector('.blog-left .arrow-prev');
    const deskNext = cardEl.querySelector('.blog-left .arrow-next');
    const deskDots = document.getElementById('dots-' + id);

    const mobPrev = cardEl.querySelector('.mobile-controls .arrow-prev');
    const mobNext = cardEl.querySelector('.mobile-controls .arrow-next');
    const mobDots = document.getElementById('mobile-dots-' + id);

    function buildDots(container) {
      if (!container) return;
      container.innerHTML = '';

      slides.forEach((_, i) => {
        const dot = document.createElement('div');
        dot.className = 'dot' + (i === 0 ? ' active' : '');
        dot.addEventListener('click', () => goTo(i));
        container.appendChild(dot);
      });
    }

    function updateDots() {
      [deskDots, mobDots].forEach(container => {
        if (!container) return;
        container.querySelectorAll('.dot').forEach((dot, i) => {
          dot.classList.toggle('active', i === current);
        });
      });
    }

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      updateDots();
    }

    if (deskPrev) deskPrev.addEventListener('click', () => goTo(current - 1));
    if (deskNext) deskNext.addEventListener('click', () => goTo(current + 1));
    if (mobPrev) mobPrev.addEventListener('click', () => goTo(current - 1));
    if (mobNext) mobNext.addEventListener('click', () => goTo(current + 1));

    buildDots(deskDots);
    buildDots(mobDots);
  }

  document.querySelectorAll('.blog-card[data-carousel]').forEach(initCarousel);

  document.querySelectorAll('.faq-item').forEach(item => {
    const header = item.querySelector('.faq-header');
    if (!header) return;

    header.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');

      document.querySelectorAll('.faq-item').forEach(i => {
        i.classList.remove('open');
        const toggle = i.querySelector('.faq-toggle');
        if (toggle) toggle.textContent = '+';
      });

      if (!isOpen) {
        item.classList.add('open');
        const toggle = item.querySelector('.faq-toggle');
        if (toggle) toggle.textContent = '−';
      }
    });
  });
});